import { type ReactNode } from 'react';
import { useSubMenu } from './SubMenuContext';
import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
interface ContentProps {
	id: string;
	children: ReactNode;
}

const Content = ({ id, children }: ContentProps) => {
	const { state, sideWidth } = useSubMenu();
	const isOpen = state[id] || false;

	return (
		<AnimatePresence mode='popLayout'>
			{isOpen && (
				<>
					<motion.div
						key={id}
						exit={{ width: 0, opacity: 1 }}
						initial={{ width: isOpen ? 0 : sideWidth, opacity: 1 }}
						animate={{ width: sideWidth, opacity: 1 }}
						className={twMerge(`overflow-hidden  h-full max-[460px]:absolute max-[460px]:z-[1] max-[460px]:!opacity-100 z-0`, `${isOpen ? 'rounded-tr-xl' : ''}`)} style={{ width: `${sideWidth}px` }}>
						<div className={` h-[calc(100%-45px)] !py-[0px] pl-[2px] pr-[0px]`} style={{ width: `${sideWidth}px` }}>
							<div className='overflow-y-auto !overflow-hidden h-full px-[0px] custom-scroll flex flex-col pr-[0px]'>{children}</div>
						</div>
					</motion.div>
				</>
			)}
		</AnimatePresence>
	);
};

export default Content;
